import { useState } from "react";

export default function Contact() {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <div className="container page-animate pb-5" style={{ paddingTop: "140px" }}>
      <div className="row justify-content-center">
        <div className="col-lg-6 col-md-8">
          <div className="text-center mb-5">
            <h1 className="fw-bold mb-3">Support Console</h1>
            <p className="text-muted">
              Submit infrastructure anomalies, report false positives, or initiate contact with the engineering team.
            </p>
          </div>

          <div className="bento-card p-4 p-md-5">
            {submitted ? (
              <div className="text-center py-5 page-animate">
                <div className="icon-wrapper mx-auto mb-4" style={{ width: "64px", height: "64px" }}>
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
                </div>
                <h4 className="text-white mb-2">Transmission Logged</h4>
                <p className="text-muted small font-mono">STATUS: AWAITING REVIEW</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="page-animate">
                <div className="row g-4">
                  <div className="col-12">
                    <label className="font-mono text-muted mb-2 d-block">Operator Email</label>
                    <input type="email" className="form-control" placeholder="alias@domain.com" required />
                  </div>
                  
                  <div className="col-12">
                    <label className="font-mono text-muted mb-2 d-block">Classification</label>
                    <select className="form-select" required>
                      <option value="" disabled selected>Select category...</option>
                      <option value="false_positive">Report False Positive</option>
                      <option value="bug">Vulnerability Disclosure</option>
                      <option value="support">Technical Assistance</option>
                    </select>
                  </div>

                  <div className="col-12">
                    <label className="font-mono text-muted mb-2 d-block">Payload Data</label>
                    <textarea className="form-control" rows="5" placeholder="Provide raw logs or exact domain targets..." required></textarea>
                  </div>

                  <div className="col-12 pt-2">
                    <button type="submit" className="btn btn-primary w-100 font-mono">
                      Transmit Data
                    </button>
                  </div>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}